module.exports = __webpack_public_path__ + "img/AustraliaMap_Base.43ab5fdf.png";